import React from "react";
import { Card, Typography, Row, Col, Tag, Collapse } from "antd";
import {
  ReadOutlined,
  ApartmentOutlined,
  ProjectOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const Summary = ({ countData, totalDelta, counts }) => {
  if (!counts || !counts.combos) return null;
  const { combos, combo_totals, grand_total } = counts;

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        padding: 16,
      }}
    >
      <Row justify="space-between" style={{ marginBottom: 24 }}>
        <Col>
          <Title level={5}>Total Records: {grand_total}</Title>
        </Col>
        <Col
          style={{
            border: "1px solid #d9d9d9",
            padding: "8px 16px",
            borderRadius: 4,
          }}
        >
          <Card
            size="small"
            bordered={false}
            style={{
              backgroundColor: totalDelta < 0 ? "#ff4d4f" : "#52c41a",
              borderRadius: "4px",
              padding: "4px 10px",
              minWidth: "110px",
              textAlign: "center",
            }}
          >
            <Text strong style={{ color: "white" }}>
              Total Delta: {totalDelta.toFixed(3)}
            </Text>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        {Object.entries(combos).map(([comboKey, departments]) => {
          const comboTotal = combo_totals[comboKey];

          return (
            <Col xs={24} sm={24} md={12} lg={8} key={comboKey}>
              <Collapse accordion>
                <Panel
                  key={comboKey}
                  header={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ProjectOutlined
                        style={{ color: "#1890ff", marginRight: 8 }}
                      />
                      <strong>{comboKey}</strong>
                      <Tag color="blue" style={{ marginLeft: "auto" }}>
                        {comboTotal}
                      </Tag>
                    </div>
                  }
                >
                  {Object.entries(departments).map(([deptName, subjects]) => {
                    const subjectTotal = Object.values(subjects).reduce(
                      (a, b) => a + b,
                      0
                    );

                    return (
                      <Card
                        key={deptName}
                        type="inner"
                        title={
                          <span>
                            <ApartmentOutlined
                              style={{ marginRight: 8, color: "#722ed1" }}
                            />
                            {deptName}
                            <Tag color="purple" style={{ marginLeft: 8 }}>
                              {subjectTotal}
                            </Tag>
                          </span>
                        }
                        style={{ marginBottom: 16 }}
                      >
                        <Row gutter={[16, 16]}>
                          {Object.entries(subjects).map(([subject, count]) => (
                            <Col xs={24} sm={12} md={12} lg={12} key={subject}>
                              <Tag
                                icon={<ReadOutlined />}
                                color="volcano"
                                style={{
                                  padding: "6px 8px",
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>{subject}</span>
                                <span>{count}</span>
                              </Tag>
                            </Col>
                          ))}
                        </Row>
                      </Card>
                    );
                  })}
                </Panel>
              </Collapse>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};

export default Summary;
